import columns from '../../../react-table/helpers/columns';

export const ediTypeFormatting = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.dailyRouteLeadingCountStatus === 'EDI') {
      className = 'bg-green';
    }
  }
  return {
    className,
  };
};

export const rfidTypeFormatting = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.dailyRouteLeadingCountStatus === 'RFID') {
      className = 'bg-green';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    FilteredDateColumn,
    FilteredNumberColumn,
    FilteredTextColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredDateColumn('Start Date', 'startDate'),
        new FilteredDateColumn('Stop date ', 'endDate'),
        new FilteredTextColumn('Outbound Operator', 'outboundOperator'),
        new FilteredTextColumn('Outbound IMPC', 'outboundImpc'),
        new FilteredTextColumn('Inbound Operator', 'inboundOperator'),
        new FilteredTextColumn('Inbound IMPC', 'inboundImpc'),
      ],
    },
    {
      Header: 'Daily route leading count status',
      columns: [
        new FilteredNumberColumn('Num. of EDI', 'numOfEdi'),
        new FilteredNumberColumn('No. of MAX RFID', 'maxRFID'),
        new FilteredNumberColumn('No. of MAX EDI', 'maxEDI'),
        new FilteredNumberColumn('No. of MAX RFID (Day)', 'numMaxRFID').withGetProps(ediTypeFormatting),
        new FilteredNumberColumn('No. of MAX EDI (Day)', 'numMaxEDI').withGetProps(rfidTypeFormatting),
        new FilteredNumberColumn('No. of EDI (Day)', 'numEDI'),
      ],
    },
  ];
};
